import { v4 as uuidv4 } from 'uuid';

export type AnonymousAmplitudeIdentity = {
  deviceId: string;
  sessionId: number;
};

let anonymousAmplitudeIdentity: AnonymousAmplitudeIdentity | undefined;

export const getAnonymousAmplitudeIdentity = (): AnonymousAmplitudeIdentity => {
  anonymousAmplitudeIdentity ??= {
    deviceId: uuidv4(),
    sessionId: Date.now(),
  };
  return anonymousAmplitudeIdentity;
};

export const peekAnonymousAmplitudeIdentity = (): AnonymousAmplitudeIdentity | undefined =>
  anonymousAmplitudeIdentity;

export const resetAnonymousAmplitudeIdentity = (): void => {
  anonymousAmplitudeIdentity = undefined;
};
